/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { financialSupportCaseControllerCreate } from '../fn/financial-support-cases/financial-support-case-controller-create';
import { FinancialSupportCaseControllerCreate$Params } from '../fn/financial-support-cases/financial-support-case-controller-create';
import { financialSupportCaseControllerFindResult } from '../fn/financial-support-cases/financial-support-case-controller-find-result';
import { FinancialSupportCaseControllerFindResult$Params } from '../fn/financial-support-cases/financial-support-case-controller-find-result';
import { financialSupportCaseControllerMatchPolicyFunds } from '../fn/financial-support-cases/financial-support-case-controller-match-policy-funds';
import { FinancialSupportCaseControllerMatchPolicyFunds$Params } from '../fn/financial-support-cases/financial-support-case-controller-match-policy-funds';
import { financialSupportCaseControllerRunAnalysis } from '../fn/financial-support-cases/financial-support-case-controller-run-analysis';
import { FinancialSupportCaseControllerRunAnalysis$Params } from '../fn/financial-support-cases/financial-support-case-controller-run-analysis';
import { financialSupportCaseControllerSelect } from '../fn/financial-support-cases/financial-support-case-controller-select';
import { FinancialSupportCaseControllerSelect$Params } from '../fn/financial-support-cases/financial-support-case-controller-select';
import { FinancialSupportCaseCreatedDto } from '../models/financial-support-case-created-dto';
import { FinancialSupportCaseResultDto } from '../models/financial-support-case-result-dto';
import { FinancialSupportCaseSelectionDto } from '../models/financial-support-case-selection-dto';
import { financialSupportRunwayControllerAnalyze } from '../fn/financial-support-cases/financial-support-runway-controller-analyze';
import { FinancialSupportRunwayControllerAnalyze$Params } from '../fn/financial-support-cases/financial-support-runway-controller-analyze';
import { SgmsPolicyFundMatchDto } from '../models/sgms-policy-fund-match-dto';

@Injectable({ providedIn: 'root' })
export class FinancialSupportCasesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `financialSupportCaseControllerCreate()` */
  static readonly FinancialSupportCaseControllerCreatePath = '/api/financial-support/cases';

  /**
   * 금융지원 분석 케이스 생성.
   *
   * 기업 핵심정보를 저장하고 금융지원 분석용 비회원 세션을 발급합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportCaseControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financialSupportCaseControllerCreate$Response(params: FinancialSupportCaseControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportCaseCreatedDto>> {
    const obs = financialSupportCaseControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 금융지원 분석 케이스 생성.
   *
   * 기업 핵심정보를 저장하고 금융지원 분석용 비회원 세션을 발급합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportCaseControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financialSupportCaseControllerCreate(params: FinancialSupportCaseControllerCreate$Params, context?: HttpContext): Observable<FinancialSupportCaseCreatedDto> {
    const resp = this.financialSupportCaseControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FinancialSupportCaseCreatedDto>): FinancialSupportCaseCreatedDto => r.body)
    );
  }

  /** Path part for operation `financialSupportCaseControllerFindResult()` */
  static readonly FinancialSupportCaseControllerFindResultPath = '/api/financial-support/cases/{id}';

  /**
   * 금융지원 분석 결과 조회.
   *
   * 비회원 세션 토큰으로 금융지원 분석 케이스의 현재 결과를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportCaseControllerFindResult()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportCaseControllerFindResult$Response(params: FinancialSupportCaseControllerFindResult$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportCaseResultDto>> {
    const obs = financialSupportCaseControllerFindResult(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 금융지원 분석 결과 조회.
   *
   * 비회원 세션 토큰으로 금융지원 분석 케이스의 현재 결과를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportCaseControllerFindResult$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportCaseControllerFindResult(params: FinancialSupportCaseControllerFindResult$Params, context?: HttpContext): Observable<FinancialSupportCaseResultDto> {
    const resp = this.financialSupportCaseControllerFindResult$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FinancialSupportCaseResultDto>): FinancialSupportCaseResultDto => r.body)
    );
  }

  /** Path part for operation `financialSupportCaseControllerSelect()` */
  static readonly FinancialSupportCaseControllerSelectPath = '/api/financial-support/cases/{id}/selection';

  /**
   * 정책자금 및 지원금액 선택.
   *
   * 분석 케이스에서 검토할 정책자금과 지원금액을 선택합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportCaseControllerSelect()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financialSupportCaseControllerSelect$Response(params: FinancialSupportCaseControllerSelect$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportCaseSelectionDto>> {
    const obs = financialSupportCaseControllerSelect(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정책자금 및 지원금액 선택.
   *
   * 분석 케이스에서 검토할 정책자금과 지원금액을 선택합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportCaseControllerSelect$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financialSupportCaseControllerSelect(params: FinancialSupportCaseControllerSelect$Params, context?: HttpContext): Observable<FinancialSupportCaseSelectionDto> {
    const resp = this.financialSupportCaseControllerSelect$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FinancialSupportCaseSelectionDto>): FinancialSupportCaseSelectionDto => r.body)
    );
  }

  /** Path part for operation `financialSupportCaseControllerMatchPolicyFunds()` */
  static readonly FinancialSupportCaseControllerMatchPolicyFundsPath = '/api/financial-support/cases/{id}/policy-matches';

  /**
   * SGMS 정책자금 매칭.
   *
   * 입력한 기업정보로 5개 정책자금의 요건 충족도를 계산합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportCaseControllerMatchPolicyFunds()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportCaseControllerMatchPolicyFunds$Response(params: FinancialSupportCaseControllerMatchPolicyFunds$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SgmsPolicyFundMatchDto>>> {
    const obs = financialSupportCaseControllerMatchPolicyFunds(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * SGMS 정책자금 매칭.
   *
   * 입력한 기업정보로 5개 정책자금의 요건 충족도를 계산합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportCaseControllerMatchPolicyFunds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportCaseControllerMatchPolicyFunds(params: FinancialSupportCaseControllerMatchPolicyFunds$Params, context?: HttpContext): Observable<Array<SgmsPolicyFundMatchDto>> {
    const resp = this.financialSupportCaseControllerMatchPolicyFunds$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SgmsPolicyFundMatchDto>>): Array<SgmsPolicyFundMatchDto> => r.body)
    );
  }

  /** Path part for operation `financialSupportCaseControllerRunAnalysis()` */
  static readonly FinancialSupportCaseControllerRunAnalysisPath = '/api/financial-support/cases/{id}/analysis';

  /**
   * SGMS 금융지원 분석 실행.
   *
   * 선택한 정책자금과 금액으로 규칙 기반 분석을 완료하고 결과를 반환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportCaseControllerRunAnalysis()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportCaseControllerRunAnalysis$Response(params: FinancialSupportCaseControllerRunAnalysis$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportCaseResultDto>> {
    const obs = financialSupportCaseControllerRunAnalysis(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * SGMS 금융지원 분석 실행.
   *
   * 선택한 정책자금과 금액으로 규칙 기반 분석을 완료하고 결과를 반환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportCaseControllerRunAnalysis$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportCaseControllerRunAnalysis(params: FinancialSupportCaseControllerRunAnalysis$Params, context?: HttpContext): Observable<FinancialSupportCaseResultDto> {
    const resp = this.financialSupportCaseControllerRunAnalysis$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FinancialSupportCaseResultDto>): FinancialSupportCaseResultDto => r.body)
    );
  }

  /** Path part for operation `financialSupportRunwayControllerAnalyze()` */
  static readonly FinancialSupportRunwayControllerAnalyzePath = '/api/financial-support/cases/{id}/runway-analysis';

  /**
   * 레거시 런웨이 분석 실행.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialSupportRunwayControllerAnalyze()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportRunwayControllerAnalyze$Response(params: FinancialSupportRunwayControllerAnalyze$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = financialSupportRunwayControllerAnalyze(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 레거시 런웨이 분석 실행.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialSupportRunwayControllerAnalyze$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialSupportRunwayControllerAnalyze(params: FinancialSupportRunwayControllerAnalyze$Params, context?: HttpContext): Observable<void> {
    const resp = this.financialSupportRunwayControllerAnalyze$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
